
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3a11"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3a11"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $f98cebd3e0831e94$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["f9fpV","index.a354b56f.js","eyyUD","icons.c14567a0.svg"]'));

// API https://forkify-api.herokuapp.com/v2
const $ba30e20475feac5a$export$923ea8233b386e99 = "https://forkify-api.herokuapp.com/api/v2/recipes";
const $ba30e20475feac5a$export$a9861bd62f48e142 = "16a9f4c8-332b-4144-be5e-735837221cfb";
const $ba30e20475feac5a$export$196440f71ed9f601 = 5;
const $ba30e20475feac5a$export$d2f17d20365655cb = 10;
const $ba30e20475feac5a$export$b1eadd190d8a533f = "bookmarks";
const $ba30e20475feac5a$export$3444686aafd725ae = 2.5;
const $ba30e20475feac5a$export$52744ab1215fb769 = 980;




/**
 * Throw timeout error
 * @param {number} s
 * @returns {Promise<unknown>}
 */ const $d734639fc9855315$var$timeout = function(s = (0, $ba30e20475feac5a$export$196440f71ed9f601)) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} ${s >= 2 ? "seconds" : "second"}`));
        }, s * 1000);
    });
};
const $d734639fc9855315$export$d047a7c56db64af4 = async function(url) {
    try {
        const res = await Promise.race([
            fetch(url),
            $d734639fc9855315$var$timeout()
        ]);
        const recipeResponseData = await res.json();
        if (!res.ok) throw new Error(`${recipeResponseData?.message} (${recipeResponseData?.status})`);
        return recipeResponseData;
    } catch (err) {
        throw err;
    }
};
const $d734639fc9855315$export$39e0fd3547bcb345 = async function(url, uploadData) {
    try {
        const sendData = fetch(url, {
            method: "post",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(uploadData)
        });
        const res = await Promise.race([
            sendData,
            $d734639fc9855315$var$timeout()
        ]);
        const responseData = await res.json();
        if (!res.ok) throw new Error(`${responseData?.message} (${responseData?.status})`);
        return responseData;
    } catch (err) {
        throw err;
    }
};


const $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    recipe: {},
    search: {
        query: "",
        results: [],
        page: 1,
        resultsPerPage: (0, $ba30e20475feac5a$export$d2f17d20365655cb)
    },
    bookmarks: []
};
/**
 * Create recipe object
 *
 * @param {object} data
 * @returns {{}|{sourceUrl: string, image: string, servings: number, publisher: string, ingredients: array, id: string, title: string, cookingTime: number}}
 */ const $0f1d4402dffacf5b$var$createRecipeObject = function(data) {
    if (!data?.recipe) return {};
    const { recipe: recipe } = data;
    return {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        sourceUrl: recipe.source_url,
        image: recipe.image_url,
        servings: recipe.servings,
        cookingTime: recipe.cooking_time,
        ingredients: recipe.ingredients,
        ...recipe.key && {
            key: recipe.key
        }
    };
};
const $0f1d4402dffacf5b$export$b96725c7a035d60b = async function(id) {
    if (!id) return;
    try {
        const recipeResponseData = await (0, $d734639fc9855315$export$d047a7c56db64af4)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}/${id}?key=${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}`);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe = $0f1d4402dffacf5b$var$createRecipeObject(recipeResponseData.data);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked = $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.some((bookmark)=>bookmark.id === id);
    } catch (err) {
        console.error(err);
        throw err;
    }
};
const $0f1d4402dffacf5b$export$202b8e5cb363a0c4 = async function(query) {
    if (!query) throw new Error("Please specify a query and try again.");
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.query = query;
    try {
        const recipeSearchResultsData = await (0, $d734639fc9855315$export$d047a7c56db64af4)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}?search=${query}&key=${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}`);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.page = 1;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results = recipeSearchResultsData.data.recipes.map((rec)=>{
            return {
                id: rec.id,
                title: rec.title,
                publisher: rec.publisher,
                image: rec.image_url,
                ...rec.key && {
                    key: rec.key
                }
            };
        });
    } catch (err) {
        console.error(err);
        throw err;
    }
};
const $0f1d4402dffacf5b$export$8d7f79465139ab72 = function(page = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.page) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.page = page;
    const start = (page - 1) * $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.resultsPerPage;
    const end = page * $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.resultsPerPage;
    return $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results.slice(start, end);
};
const $0f1d4402dffacf5b$export$5e23f4642ecad5ea = function(newServings) {
    if (!newServings) return;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.ingredients.forEach((ing)=>{
        ing.quantity = ing.quantity * newServings / $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.servings;
    });
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.servings = newServings;
};
const $0f1d4402dffacf5b$export$9cfbe2e4d0171df3 = function(recipe) {
    // Check if recipe already bookmarked
    const bookmarkedId = $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.findIndex((bookmarkedRecipe)=>bookmarkedRecipe.id === recipe.id);
    const isBookmarked = bookmarkedId !== -1;
    if (isBookmarked) // Delete bookmark
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.splice(bookmarkedId, 1);
    else // Add bookmark
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.push(recipe);
    // Mark/Unmark current recipe as bookmark
    if (recipe.id === $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.id) $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.bookmarked = !isBookmarked;
    // Save to localstorage
    $0f1d4402dffacf5b$var$persistBookmarks();
};
/**
 * Save bookmarks to localstorage
 */ const $0f1d4402dffacf5b$var$persistBookmarks = function() {
    localStorage.setItem((0, $ba30e20475feac5a$export$b1eadd190d8a533f), JSON.stringify($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks));
};
/**
 * Load stored bookmarks
 * @returns {*[]}
 */ const $0f1d4402dffacf5b$var$loadBookmarks = function() {
    const bookmarks = localStorage.getItem((0, $ba30e20475feac5a$export$b1eadd190d8a533f));
    return bookmarks ? JSON.parse(bookmarks) : [];
};
const $0f1d4402dffacf5b$export$d660c2254e74960d = async function(newRecipe) {
    try {
        const ingredients = Object.entries(newRecipe).filter((entry)=>entry[0].includes("ingredien") && entry[1] !== "").map((ing)=>{
            const ingArr = ing[1].split(",").map((el)=>el.trim());
            if (ingArr.length !== 3) throw new Error("Wrong ingredient format! Please follow the correct format.");
            const [quantity, unit, description] = ingArr;
            if (ingArr.length === 3 && !description) throw new Error("The description is required! Please specify the description.");
            return {
                quantity: quantity ? +quantity : "",
                unit: unit ? unit : "",
                description: description
            };
        });
        const recipe = {
            title: newRecipe.title,
            publisher: newRecipe.publisher,
            source_url: newRecipe.source_url,
            image_url: newRecipe.image,
            servings: +newRecipe.servings,
            cooking_time: +newRecipe.cooking_time,
            ingredients: ingredients
        };
        // Upload new recipe
        const responseData = await (0, $d734639fc9855315$export$39e0fd3547bcb345)(`${(0, $ba30e20475feac5a$export$923ea8233b386e99)}?key=${(0, $ba30e20475feac5a$export$a9861bd62f48e142)}`, recipe);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe = $0f1d4402dffacf5b$var$createRecipeObject(responseData.data);
        // Add new recipe to bookmark
        $0f1d4402dffacf5b$export$9cfbe2e4d0171df3($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        throw err;
    }
};
const $0f1d4402dffacf5b$var$init = function() {
    // Load stored bookmarks
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks = $0f1d4402dffacf5b$var$loadBookmarks();
};
$0f1d4402dffacf5b$var$init();


var $77b629c0b49e8bca$exports = {};
$77b629c0b49e8bca$exports = new URL("icons.c14567a0.svg", import.meta.url).toString();


class $989dab0c44cbb553$export$2e2bcd8739ae039 {
    _errorMessage = "";
    _message = "";
    _data;
    /**
   * Render the received object to the DOM
   *
   * @param {Object | Object[]} data
   * @param {boolean} [render=true] Determines whether to render the content or just simply return it
   * @returns {void|string}
   * @this {Object} View instance
   */ render(data, render = true) {
        if (!data || Array.isArray(data) && data.length === 0) return this.renderErrorMessage();
        this._data = data;
        const markup = this._generateMarkup();
        if (!render) return markup;
        this._clear();
        this._parentElement.innerHTML = markup;
    }
    /**
   * Update DOM with new data
   *
   * @param {object} data
   */ update(data) {
        this._data = data;
        const newMarkup = this._generateMarkup();
        /* Convert string into real virtual DOM object */ const newDOM = document.createRange().createContextualFragment(newMarkup);
        const newElements = Array.from(newDOM.querySelectorAll("*"));
        const curElements = Array.from(this._parentElement.querySelectorAll("*"));
        if (newElements.length !== curElements.length) return this.render(this._data);
        return newElements.forEach((newElem, i)=>{
            const curElem = curElements[i];
            /** isEqualNode https://developer.mozilla.org/en-US/docs/Web/API/Node/isEqualNode */ /** nodeValue https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeValue */ if (!newElem.isEqualNode(curElem)) {
                /* Update changed text */ if (newElem?.firstChild?.nodeValue?.trim() !== "") curElem.textContent = newElem.textContent;
                /* Update changed attributes */ Array.from(newElem.attributes).forEach((attr)=>curElem.setAttribute(attr.name, attr.value));
            }
        });
    }
    /**
   * Clear parent content
   *
   * @param {Element} parentElement
   * @private
   */ _clear(parentElement = this._parentElement) {
        parentElement.innerHTML = "";
    }
    /**
   * Render error message
   *
   * @param {string} message
   * @param {boolean} render
   * @returns {string}
   */ /**
   * Render error message
   *
   * @param {string} message
   * @param {Element} parentElement
   * @returns {string}
   */ renderErrorMessage(message = this._errorMessage, parentElement = this._parentElement) {
        const markup = `
      <div class="error">
        <div>
          <svg>
            <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports)))}#icon-alert-triangle"></use>
          </svg>
        </div>
        <p>${message}</p>
      </div>
    `;
        this._clear(parentElement);
        parentElement.innerHTML = markup;
    }
    /**
   * Render message
   *
   * @param {string} message
   */ renderMessage(message = this._message) {
        const markup = `
      <div class="message">
        <div>
          <svg>
            <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports)))}#icon-smile"></use>
          </svg>
        </div>
        <p>${message}</p>
      </div>
    `;
        this._clear();
        this._parentElement.innerHTML = markup;
    }
    /**
   * Render loader spinner
   */ renderSpinner() {
        const markup = `
      <div class="spinner">
        <svg>
          <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports)))}#icon-loader"></use>
        </svg>
      </div>
    `;
        this._clear();
        this._parentElement.innerHTML = markup;
    }
}



var $af517d3060c307fe$exports = {};
// FRACTY CONVERTS DECIMAL NUMBERS TO FRACTIONS BY ASSUMING THAT TRAILING PATTERNS FROM 10^-2 CONTINUE TO REPEAT
// The assumption is based on the most standard numbering conventions
// e.g. 3.51 will convert to 3 51/100 while 3.511 will convert to 3 23/45
// Throw any number up to 16 digits long at fracty and let fracy do the work.
// If number is beyond 16 digits fracty will truncate at 15 digits to compensate for roundoff errors created in IEEE 754 Floating Point conversion.
$af517d3060c307fe$exports = function(number) {
    let type;
    if (number < 0) {
        number = Math.abs(number);
        type = "-";
    } else type = "";
    if (number === undefined) return `Your input was undefined.`;
    if (isNaN(number)) return `"${number}" is not a number.`;
    if (number == 9999999999999999) return `${type}9999999999999999`;
    if (number > 9999999999999999) return `Too many digits in your integer to maintain IEEE 754 Floating Point conversion accuracy.`;
    if (Number.isInteger(number)) return `${type}${number}`;
    if (number < .000001) return "0";
    const numberString = number.toString();
    const entry = numberString.split(".");
    let integer = entry[0];
    let decimal;
    if (decimal == "0" && integer !== "0") return integer;
    else if (decimal == "0" && integer == "0") return "0";
    else if (numberString.length >= 17) decimal = entry[1].slice(0, entry[1].length - 1);
    else decimal = entry[1];
    if (decimal == "99" && integer !== "0") return `${integer} 99/100`;
    else if (decimal == "99" && integer == "0") return `99/100`;
    else if (1 - parseFloat(`.${decimal}`) < .0011) decimal = "999";
    if (decimal == undefined) return integer;
    const decimalRev = decimal.split("").reverse().join(""); //Reverse the string to look for patterns.
    const patternSearch = /^(\d+)\1{1,2}/; //This greedy regex matches the biggest pattern that starts at the beginning of the string (at the end, in the case of the reversed string). A lazy regex doesn't work because it only identifies subpatterns in cases where subpatterns exist (e.g. '88' in '388388388388'), thus pattern capture must be greedy.
    let pattern = decimalRev.match(patternSearch); //If there's a pattern, it's full sequence is in [0] of this array and the single unit is in [1] but it may still need to be reduced further.
    if (pattern && decimal.length > 2) {
        let patternSequence = pattern[0].split("").reverse().join("");
        let endPattern = pattern[1].split("").reverse().join("");
        if (endPattern.length > 1) {
            let endPatternArray = endPattern.split("");
            let testSingleUnit = 1;
            for(let i = 0; i < endPatternArray.length; i++)testSingleUnit /= endPatternArray[0] / endPatternArray[i];
            if (testSingleUnit === 1) endPattern = endPatternArray[0];
        }
        if (endPattern.length > 1 && endPattern.length % 2 === 0) endPattern = parseInt(endPattern.slice(0, endPattern.length / 2), 10) - parseInt(endPattern.slice(endPattern.length / 2, endPattern.length), 10) === 0 ? endPattern.slice(0, endPattern.length / 2) : endPattern;
        return $af517d3060c307fe$var$yesRepeat(decimal, endPattern, patternSequence, integer, type); //Begin calculating the numerator and denominator for decimals that have a pattern.
    } else return $af517d3060c307fe$var$noRepeat(decimal, integer, type); //Begin calculating the numerator and denominator for decimals that don't have a pattern.
};
//IF THERE'S A TRAILING PATTERN FRACTY DIVIDES THE INPUT BY ONE SUBTRACTED FROM THE NEAREST BASE 10 NUMBER WITH NUMBER OF ZEROS EQUAL TO THE LENGTH OF THE REPEATED PATTERN (I.E. A SERIES OF 9'S) MULTIPLIED BY THE BASE 10 NUMBER GREATER THAN AND CLOSEST TO THE INPUT.
function $af517d3060c307fe$var$yesRepeat(decimal, endPattern, patternSequence, integer, type) {
    const rep = true; //The numerator repeats.
    const nonPatternLength = decimal.length - patternSequence.length >= 1 ? decimal.length - patternSequence.length : 1; //Does the length of the non pattern segment of the input = 0? If it does, that's incorrect since we know it must equal at least 1, otherwise it's the length of the decimal input minus the length of the full pattern.
    const decimalMultiplier2 = Math.pow(10, nonPatternLength); //Second multiplier to use.
    const float = parseFloat(`0.${decimal}`); //Convert the decimal input to a floating point number.
    const decimalMultiplier1 = Math.pow(10, endPattern.length); //Find the right multiplier to use for both numerator and denominator, which will later have 1 subtracted from it in the case of the denominator.
    const numerator = Math.round((float * decimalMultiplier1 - float) * Math.pow(10, nonPatternLength)); //Find the numerator to be used in calculating the fraction that contains a repeating trailing sequence.
    const denominator = (decimalMultiplier1 - 1) * decimalMultiplier2; //Caluculate the denominator using the equation for repeating trailing sequences.
    return $af517d3060c307fe$var$reduce(numerator, denominator, integer, type, rep); //Further reduce the numerator and denominator.
}
//IF THERE'S NO TRAILING PATTERN FRACTY DIVIDES THE INPUT BY THE NEAREST BASE 10 INTEGER GREATER THAN THE NUMERATOR.
function $af517d3060c307fe$var$noRepeat(decimal, integer, type) {
    const rep = false; //The numerator doesn't repeat.
    const numerator = parseInt(decimal, 10); //Numerator begins as decimal input converted into an integer.
    const denominator = Math.pow(10, decimal.length); //Denominator begins as 10 to the power of the length of the numerator.
    return $af517d3060c307fe$var$reduce(numerator, denominator, integer, type, rep); //Reduce the numerator and denominator.
}
//FRACTY REDUCES THE FRACTION.
function $af517d3060c307fe$var$reduce(numerator, denominator, integer, type, rep) {
    const primeNumberArray = [
        2,
        3,
        5
    ]; //If the numerator isn't from a repeating decimal case, the initialized array of prime numbers will suffice to find the common denominators.
    if (rep === true) {
        for(let i = 3; i * i <= numerator; i += 2)if (numerator % i === 0) primeNumberArray.push(i);
    }
    let j = 0; //Initialize counter over the prime number array for the while loop.
    let comDenom = 1; //Initialize the common denominator.
    let num = numerator; //Initialize the numerator.
    let den = denominator; //Initialize the denominator.
    while(j <= primeNumberArray.length)if (num % primeNumberArray[j] === 0 && den % primeNumberArray[j] === 0) {
        comDenom = comDenom * primeNumberArray[j];
        num = num / primeNumberArray[j];
        den = den / primeNumberArray[j];
    } else j++;
    return $af517d3060c307fe$var$returnStrings(den, num, integer, type);
}
//FRACTY RETURNS THE REDUCED FRACTION AS A STRING.
function $af517d3060c307fe$var$returnStrings(den, num, integer, type) {
    if (den === 1 && num === 1) {
        integer = `${type}${(parseInt(integer) + 1).toString()}`; //Add 1 to the integer and return a string without a fraction.
        return `${integer}`;
    } else if (num === 0) return `${type}${integer}`;
    else if (integer == "0") return `${type}${num}/${den}`;
    else return `${type}${integer} ${num}/${den}`; //If there's an integer and a fraction return both.
}


let $9a2fcb415d31b267$var$currentTrap;
const $9a2fcb415d31b267$export$e2690578cac908dd = (rootElement)=>{
    const selector = "button, [href], input, select, textarea, details";
    return Array.from(rootElement.querySelectorAll(selector)).filter((el)=>el.style.display !== "none" && !el.disabled && el.tabIndex !== -1);
};
/**
 * Set area of focus
 *
 * @param e
 */ const $9a2fcb415d31b267$var$focusTrap = (e)=>{
    const isTabPressed = e.key === "Tab" || e.keyCode === 9;
    if (!isTabPressed) return;
    const focusable = $9a2fcb415d31b267$export$e2690578cac908dd($9a2fcb415d31b267$var$currentTrap);
    const firstFocusableElement = focusable[0];
    const lastFocusableElement = focusable[focusable.length - 1];
    e.shiftKey ? document.activeElement === firstFocusableElement && (lastFocusableElement.focus(), e.preventDefault()) : document.activeElement === lastFocusableElement && (firstFocusableElement.focus(), e.preventDefault());
};
const $9a2fcb415d31b267$export$6e151c0ad71c021a = (rootElement = null)=>{
    if ($9a2fcb415d31b267$var$currentTrap && (!rootElement || rootElement === $9a2fcb415d31b267$var$currentTrap)) {
        $9a2fcb415d31b267$var$currentTrap.removeEventListener("keydown", $9a2fcb415d31b267$var$focusTrap);
        $9a2fcb415d31b267$var$currentTrap = null;
    }
};
const $9a2fcb415d31b267$export$bec45a54c2e66c22 = (rootElement)=>{
    if (!rootElement) return;
    $9a2fcb415d31b267$export$6e151c0ad71c021a();
    $9a2fcb415d31b267$var$currentTrap = rootElement;
    rootElement.addEventListener("keydown", $9a2fcb415d31b267$var$focusTrap);
    const firstElement = $9a2fcb415d31b267$export$e2690578cac908dd(rootElement)[0];
    firstElement && firstElement.focus();
};


class $5dccb45da00d85a7$var$RecipeView extends (0, $989dab0c44cbb553$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".recipe");
    _errorMessage = "We couldn't find that recipe. Please try another one!";
    /**
   * @param {Function} handler
   */ addHandlerRender(handler) {
        /** Run controlRecipes method on hashchange and page load events */ [
            "hashchange",
            "load"
        ].forEach((ev)=>window.addEventListener(ev, handler));
    }
    /**
   * @param {Function} handler
   */ addHandlerUpdateServings(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--tiny");
            if (!btn) return;
            const updateToNumber = +btn.dataset.updateTo;
            if (updateToNumber > 0) handler(updateToNumber);
        });
    }
    /**
   * @param {Function} handler
   */ addHandlerManageBookmark(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--bookmark");
            if (btn) handler();
        });
    }
    /**
   * Trap focus to the first focusable element of the recipe view
   */ trapFocusToRecipeView() {
        (0, $9a2fcb415d31b267$export$e2690578cac908dd)(this._parentElement)?.[0]?.focus();
    }
    /**
   * Generate recipe markup
   *
   * @returns {string}
   */ _generateMarkup() {
        return `
      <figure class="recipe__fig">
        <img src="${this._data.image}" alt="${this._data.title}" class="recipe__img" loading="lazy" />
        <h1 class="recipe__title">
          <span>${this._data.title}</span>
        </h1>
      </figure>

      <div class="recipe__details">
        <div class="recipe__info-wrapper">
          <div class="recipe__info">
            <svg class="recipe__info-icon">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-clock"></use>
            </svg>
            <span class="recipe__info-data recipe__info-data--minutes">${this._data.cookingTime}</span>
            <span class="recipe__info-text">minutes</span>
          </div>
          <div class="recipe__info">
            <svg class="recipe__info-icon">
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-users"></use>
            </svg>
            <span class="recipe__info-data recipe__info-data--people">${this._data.servings}</span>
            <span class="recipe__info-text">servings</span>
  
            <div class="recipe__info-buttons">
              <button class="btn--tiny btn--update-servings" data-update-to="${this._data.servings - 1}" role="button">
                <svg>
                  <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-minus-circle"></use>
                </svg>
              </button>
              <button class="btn--tiny btn--update-servings" data-update-to="${this._data.servings + 1}" role="button">
                <svg>
                  <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-plus-circle"></use>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="recipe__user-generated ${this._data.key ? "" : "sr-only"}">
          <svg>
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-user"></use>
          </svg>
        </div>
        <button class="btn--round btn--bookmark" role="button">
          <svg>
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-bookmark${this._data.bookmarked ? "-fill" : ""}"></use>
          </svg>
        </button>
      </div>

      <div class="recipe__ingredients">
        <h2 class="heading--2">Recipe ingredients</h2>
        <ul class="recipe__ingredient-list">
          ${this._data.ingredients.map(this._generateMarkupIngredient).join("")}
        </ul>
      </div>

      <div class="recipe__directions">
        <h2 class="heading--2">How to cook it</h2>
        <p class="recipe__directions-text">
          This recipe was carefully designed and tested by
          <span class="recipe__publisher">${this._data.publisher}</span>. Please check out
          directions at their website.
        </p>
        <a
          class="btn--small recipe__btn"
          href="${this._data.sourceUrl}"
          target="_blank"
        >
          <span>Directions</span>
          <svg class="search__icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-arrow-right"></use>
          </svg>
        </a>
      </div>
    `;
    }
    /**
   * Generate ingredient markup
   *
   * @param {object} ing
   * @returns {string}
   */ _generateMarkupIngredient(ing) {
        return `
      <li class="recipe__ingredient">
        <svg class="recipe__icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-check"></use>
        </svg>
        <div class="recipe__quantity">${ing.quantity ? (0, (/*@__PURE__*/$parcel$interopDefault($af517d3060c307fe$exports)))(ing.quantity) : ""}</div>
        <div class="recipe__description">
          <span class="recipe__unit">${ing.unit}</span>
          ${ing.description}
        </div>
      </li>
    `;
    }
}
var $5dccb45da00d85a7$export$2e2bcd8739ae039 = new $5dccb45da00d85a7$var$RecipeView();



class $517cf2ae0791ab9c$var$SearchView {
    _parentElement = document.querySelector(".search");
    _searchInput = this._parentElement.querySelector(".search__field");
    _matchMediaAttached = false;
    /**
   * Get search query
   *
   * @param {boolean} clearInput
   * @returns {*}
   */ getQuery(clearInput = true) {
        const query = this._searchInput.value.trim();
        clearInput && this._clearInput();
        return query;
    }
    /**
   * @param {Function} handler
   */ addHandlerSearch(handler) {
        this._parentElement.addEventListener("submit", (e)=>{
            e.preventDefault();
            this._handleMobileSearch();
            this.getQuery(false) && handler();
        });
    }
    /**
   * Clear input
   */ _clearInput() {
        this._searchInput.value = "";
    }
    /**
   * Handle search visibility on mobile
   *
   * @returns {(function(): void)|void}
   * @private
   */ _handleMobileSearch() {
        if (!this._searchInput) return;
        const self = this;
        const activeClass = "active";
        const mobileEdge = (0, $ba30e20475feac5a$export$52744ab1215fb769);
        // Toggle active class and aria-hidden attribute
        if (window.innerWidth < mobileEdge) {
            self._searchInput.classList.toggle(activeClass);
            const isSearchInputHasActiveClass = self._searchInput.classList.contains(activeClass);
            self._searchInput.setAttribute("aria-hidden", !isSearchInputHasActiveClass);
            // Move focus to input when it has shown
            setTimeout(()=>{
                isSearchInputHasActiveClass ? self._searchInput.focus() : self._searchInput.nextElementSibling.focus();
            }, 50);
        }
        if (this._matchMediaAttached) return;
        return ()=>{
            this._matchMediaAttached = true;
            // Remove active class and aria-hidden attribute based on matchMedia condition
            const matchMedia = window.matchMedia(`(min-width: ${mobileEdge}px)`);
            matchMedia.addEventListener("change", function(m) {
                if (m.matches) {
                    self._searchInput.classList.remove(activeClass);
                    self._searchInput.removeAttribute("aria-hidden");
                }
            });
        };
    }
}
var $517cf2ae0791ab9c$export$2e2bcd8739ae039 = new $517cf2ae0791ab9c$var$SearchView();





class $16678c08e197fe6d$var$PreviewView extends (0, $989dab0c44cbb553$export$2e2bcd8739ae039) {
    _parentElement = "";
    _generateMarkup() {
        const id = window.location.hash.slice(1);
        return `
      <li class="preview">
        <a class="preview__link ${this._data.id === id ? "preview__link--active" : ""}" href="#${this._data.id}">
          <figure class="preview__fig">
            <img src="${this._data.image}" alt="${this._data.title}" />
          </figure>
          <div class="preview__data">
            <h4 class="preview__title">
              ${this._data.title}
            </h4>
            <p class="preview__publisher">${this._data.publisher}</p>
            <div class="recipe__user-generated ${this._data.key ? "" : "sr-only"}">
              <svg>
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-user"></use>
              </svg>
            </div>
          </div>
        </a>
      </li>
    `;
    }
}
var $16678c08e197fe6d$export$2e2bcd8739ae039 = new $16678c08e197fe6d$var$PreviewView();




class $83c3e61b520da8ec$var$ResultView extends (0, $989dab0c44cbb553$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".results");
    _errorMessage = "No recipes found for your query! Please try another one.";
    _searchResultsTrigger = document.querySelector(".search-results-trigger");
    _skipToRecipe = "";
    _skipToRecipeEventAttached = false;
    _isSearchResultsTriggerEventAttached = false;
    constructor(){
        super();
        this.toggleRecipeSearchResult();
    }
    /**
   * Generate search result markup
   *
   * @returns {string}
   * @private
   */ _generateMarkup() {
        this._data.length && !this._skipToRecipe && this._createSkipToRecipe();
        return this._data.map((result)=>(0, $16678c08e197fe6d$export$2e2bcd8739ae039).render(result, false)).join("");
    }
    /**
   * Create, render and attach the event to the Skip to recipe button
   *
   * @private
   */ _createSkipToRecipe() {
        if (this._skipToRecipe) return;
        this._parentElement.previousElementSibling.innerHTML = `<button class="skip-to-recipe__cta" type="button">Skip to recipe</button>`;
        this._skipToRecipe = document.querySelector(".skip-to-recipe__cta");
        this.handleSkipToRecipeCta();
    }
    /**
   * Toggle search result section visibility
   *
   * @param {boolean} forceOpen
   * @param {boolean} forceClose
   */ toggleRecipeSearchResult(forceOpen = false, forceClose = false) {
        const self = this;
        const activeClass = "active";
        /**
     *  Toggle recipe search result section active class and aria-hidden attribute value
     */ const toggleRecipeSearchResultSection = ()=>{
            if (window.innerWidth >= (0, $ba30e20475feac5a$export$52744ab1215fb769)) return;
            if (forceOpen) {
                self._searchResultsTrigger.classList.add(activeClass);
                self._parentElement.parentElement.classList.add(activeClass);
            } else if (forceClose) {
                self._searchResultsTrigger.classList.remove(activeClass);
                self._parentElement.parentElement.classList.remove(activeClass);
            } else {
                self._searchResultsTrigger.classList.toggle(activeClass);
                self._parentElement.parentElement.classList.toggle(activeClass);
            }
            self._parentElement.parentElement.setAttribute("aria-hidden", !self._parentElement.parentElement.classList.contains(activeClass));
        };
        (forceOpen || forceClose) && toggleRecipeSearchResultSection();
        if (this._isSearchResultsTriggerEventAttached) return;
        self._isSearchResultsTriggerEventAttached = true;
        // Toggle recipe search result section on menu button click
        self._searchResultsTrigger.addEventListener("click", toggleRecipeSearchResultSection);
        // Close recipe search result section on hashchange
        window.addEventListener("hashchange", ()=>this.toggleRecipeSearchResult(false, true));
        // Toggle accessibility attributes based on screen width
        const mql = window.matchMedia(`(min-width: ${(0, $ba30e20475feac5a$export$52744ab1215fb769)}px)`);
        self._parentElement.parentElement.setAttribute("aria-modal", !mql.matches);
        !mql.matches && self._parentElement.parentElement.setAttribute("aria-hidden", "true");
        mql.addEventListener("change", function(m) {
            self._parentElement.parentElement.setAttribute("aria-modal", !m.matches);
            m.matches ? self._parentElement.parentElement.removeAttribute("aria-hidden") : self._parentElement.parentElement.setAttribute("aria-hidden", !self._parentElement.parentElement.classList.contains(activeClass));
        });
    }
    /**
   * Handle skip to recipe view cta button click
   */ handleSkipToRecipeCta() {
        if (this._skipToRecipeEventAttached) return;
        this._skipToRecipeEventAttached = true;
        this._skipToRecipe.addEventListener("click", ()=>{
            (0, $5dccb45da00d85a7$export$2e2bcd8739ae039).trapFocusToRecipeView.call((0, $5dccb45da00d85a7$export$2e2bcd8739ae039));
            if (window.innerWidth < (0, $ba30e20475feac5a$export$52744ab1215fb769)) this.toggleRecipeSearchResult(false, true);
        });
    }
}
var $83c3e61b520da8ec$export$2e2bcd8739ae039 = new $83c3e61b520da8ec$var$ResultView();




class $541a895ca414b984$var$PaginationView extends (0, $989dab0c44cbb553$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".pagination");
    /**
   * @param {Function} handler
   */ addHandlerClick(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--inline");
            if (btn) handler(+btn.dataset.goto);
        });
    }
    /**
   * Generate pagination markup
   *
   * @returns {string}
   * @private
   */ _generateMarkup() {
        const numPages = Math.floor(this._data.results.length / this._data.resultsPerPage);
        const currentPage = this._data.page;
        /* page 1 and other pages */ if (currentPage === 1 && numPages > 1) return this._generateNextButton(currentPage + 1);
        /* last page */ if (currentPage >= numPages && numPages > 1) return this._generatePrevButton(currentPage - 1);
        /* other pages */ if (currentPage < numPages) return `
        ${this._generatePrevButton(currentPage - 1)}
        ${this._generateNextButton(currentPage + 1)}
      `;
        /* page 1, and there are no other pages */ return "";
    }
    /**
   * Generate previous button markup
   *
   * @param {number} page
   * @returns {string}
   * @private
   */ _generatePrevButton(page) {
        return `
      <button data-goto="${page}" class="btn--inline pagination__btn--prev" role="button">
        <svg class="search__icon">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-arrow-left"></use>
        </svg>
        <span>Page ${page}</span>
      </button>
    `;
    }
    /**
   * Generate next button markup
   *
   * @param {number} page
   * @returns {string}
   * @private
   */ _generateNextButton(page) {
        return `
      <button data-goto="${page}" class="btn--inline pagination__btn--next" role="button">
        <span>Page ${page}</span>
        <svg class="search__icon">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($77b629c0b49e8bca$exports))}#icon-arrow-right"></use>
        </svg>
      </button>
    `;
    }
}
var $541a895ca414b984$export$2e2bcd8739ae039 = new $541a895ca414b984$var$PaginationView();




class $0d7f39475006b124$var$BookmarksView extends (0, $989dab0c44cbb553$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".bookmarks__list");
    _bookmarkBtn = document.querySelector(".nav__btn--bookmarks");
    _errorMessage = "No bookmarks yet. Find a nice recipe and bookmark it :)";
    constructor(){
        super();
        this._toggleBookmarks();
    }
    _generateMarkup() {
        this._setBookmarkActiveIcon();
        return this._data.map((bookmark)=>(0, $16678c08e197fe6d$export$2e2bcd8739ae039).render(bookmark, false)).join("");
    }
    /**
   * Toggle bookmarks visibility
   *
   * @private
   */ _toggleBookmarks() {
        this._bookmarkBtn.addEventListener("click", ()=>{
            this._bookmarkBtn.classList.toggle("active");
        });
    }
    /**
   * Set bookmarks active icon
   *
   * @private
   */ _setBookmarkActiveIcon() {
        if (this._data.length) {
            const bookmarkBtnIcon = this._bookmarkBtn.querySelector("use");
            const bookmarkFillBtn = "icon-bookmark-fill";
            if (bookmarkBtnIcon.getAttribute("href").search(bookmarkFillBtn) >= 0) return;
            bookmarkBtnIcon.setAttribute("href", this._bookmarkBtn.querySelector("use").href.baseVal.replace("icon-bookmark", bookmarkFillBtn));
        }
    }
}
var $0d7f39475006b124$export$2e2bcd8739ae039 = new $0d7f39475006b124$var$BookmarksView();




class $8d92b1bf26236594$var$AddRecipeView extends (0, $989dab0c44cbb553$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".upload");
    _newRecipeWindow = document.querySelector(".add-recipe-window");
    _newRecipeWindowOverlay = document.querySelector(".overlay");
    _newRecipeWindowCloseBtn = this._newRecipeWindow.querySelector(".btn--close-modal");
    _addRecipeBtn = document.querySelector(".nav__btn--add-recipe");
    _errorMessageContainer = document.querySelector(".upload__error-container");
    _message = "Recipe was successfully uploaded!";
    constructor(){
        super();
        this._addHandlerToggleNewRecipeWindow();
    }
    /**
   * Toggle new recipe window visibility
   */ _addHandlerToggleNewRecipeWindow() {
        [
            this._addRecipeBtn,
            this._newRecipeWindowCloseBtn
        ].forEach((button)=>button.addEventListener("click", this.toggleNewRecipeWindow.bind(this)));
    }
    /**
   * Toggle new recipe modal window
   *
   * @param {PointerEvent} ev
   * @param {boolean} [forceClose=false]
   */ toggleNewRecipeWindow(ev, forceClose = false) {
        const toggleClass = "hidden";
        if (forceClose) {
            this._newRecipeWindow.classList.add(toggleClass);
            this._newRecipeWindowOverlay.classList.add(toggleClass);
            this._newRecipeWindow.setAttribute("aria-hidden", "true");
            this._newRecipeWindowOverlay.setAttribute("aria-hidden", "true");
            this._addRecipeBtn.focus();
        } else {
            this._newRecipeWindow.classList.toggle(toggleClass);
            this._newRecipeWindowOverlay.classList.toggle(toggleClass);
            const isActive = !this._newRecipeWindow.classList.contains(toggleClass);
            this._newRecipeWindow.setAttribute("aria-hidden", isActive);
            this._newRecipeWindowOverlay.setAttribute("aria-hidden", isActive);
            (0, $9a2fcb415d31b267$export$bec45a54c2e66c22)(isActive ? this._newRecipeWindow : this._addRecipeBtn.focus());
        }
    }
    /**
   * Render error message
   *
   * @param {string} message
   * @param {Element} parentElement
   * @returns {string}
   */ renderErrorMessage(message = this._errorMessage, parentElement = this._errorMessageContainer) {
        return super.renderErrorMessage(message, parentElement);
    }
    /**
   * Add recipe upload handler
   *
   * @param {function} handler
   */ addHandlerRecipeUpload(handler) {
        this._parentElement.addEventListener("submit", function(e) {
            e.preventDefault();
            const formDataArr = [
                ...new FormData(this)
            ];
            const data = Object.fromEntries(formDataArr);
            handler(data);
        });
    }
}
var $8d92b1bf26236594$export$2e2bcd8739ae039 = new $8d92b1bf26236594$var$AddRecipeView();


/**
 * Load and render recipe
 *
 * @returns {Promise<void>}
 */ const $f50bd1f2915ed0f2$var$controlRecipes = async function() {
    try {
        const hashId = window.location.hash.slice(1);
        if (!hashId) return;
        (0, $5dccb45da00d85a7$export$2e2bcd8739ae039).renderSpinner();
        // 1) Update results view to mark selected search results
        (0, $83c3e61b520da8ec$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$8d7f79465139ab72());
        // 2) Load recipe
        await $0f1d4402dffacf5b$export$b96725c7a035d60b(hashId);
        // 3) Render recipe
        (0, $5dccb45da00d85a7$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
        // 4) Update bookmarks
        (0, $0d7f39475006b124$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks);
    } catch (err) {
        (0, $5dccb45da00d85a7$export$2e2bcd8739ae039).renderErrorMessage();
    }
};
/**
 * Update the recipe view
 *
 * @param {number} servingsQty
 */ const $f50bd1f2915ed0f2$var$controlServings = function(servingsQty) {
    // 1) Update recipe
    $0f1d4402dffacf5b$export$5e23f4642ecad5ea(servingsQty);
    // 2) Render recipe
    (0, $5dccb45da00d85a7$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
};
/**
 * Prepare and render search results page and pagination
 *
 * @returns {Promise<void>}
 */ const $f50bd1f2915ed0f2$var$controlSearchResults = async function() {
    try {
        (0, $83c3e61b520da8ec$export$2e2bcd8739ae039).renderSpinner();
        // 1) Get search query and load search results
        await $0f1d4402dffacf5b$export$202b8e5cb363a0c4((0, $517cf2ae0791ab9c$export$2e2bcd8739ae039).getQuery());
        // 2) Render search results
        (0, $83c3e61b520da8ec$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$8d7f79465139ab72());
        // 3) Render pagination
        (0, $541a895ca414b984$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.search);
        // 4) Open search result section on mobile
        if (window.innerWidth < (0, $ba30e20475feac5a$export$52744ab1215fb769)) (0, $83c3e61b520da8ec$export$2e2bcd8739ae039).toggleRecipeSearchResult(true);
    } catch (err) {
        console.error(err);
    }
};
/**
 * Render updated pagination
 *
 * @param {number} page
 */ const $f50bd1f2915ed0f2$var$controlPagination = function(page) {
    // 1) Render new search results
    (0, $83c3e61b520da8ec$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$8d7f79465139ab72(page));
    // 3) Render new pagination
    (0, $541a895ca414b984$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.search);
};
/**
 * Control bookmarks (add/delete them)
 */ const $f50bd1f2915ed0f2$var$controlManageBookmark = function() {
    // 1) Add/Remove bookmark
    $0f1d4402dffacf5b$export$9cfbe2e4d0171df3($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
    // 2) Update recipe view
    (0, $5dccb45da00d85a7$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
    // 3) Render bookmark
    (0, $0d7f39475006b124$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks);
};
/**
 * Add new recipe
 *
 * @param {object} newRecipe
 * @returns {Promise<void>}
 */ const $f50bd1f2915ed0f2$var$controlAddNewRecipe = async function(newRecipe) {
    try {
        // Show loading spinner
        (0, $8d92b1bf26236594$export$2e2bcd8739ae039).renderSpinner();
        // Upload new recipe
        await $0f1d4402dffacf5b$export$d660c2254e74960d(newRecipe);
        // Render new recipe
        (0, $5dccb45da00d85a7$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe);
        // Show success message
        (0, $8d92b1bf26236594$export$2e2bcd8739ae039).renderMessage();
        // Render bookmark
        (0, $0d7f39475006b124$export$2e2bcd8739ae039).update($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks);
        // Change ID the URL
        window.history.pushState(null, "", `#${$0f1d4402dffacf5b$export$ca000e230c0caa3e.recipe.id}`);
        // Close new recipe form window
        setTimeout((e)=>(0, $8d92b1bf26236594$export$2e2bcd8739ae039).toggleNewRecipeWindow(e, true), (0, $ba30e20475feac5a$export$3444686aafd725ae) * 1000);
    } catch (err) {
        (0, $8d92b1bf26236594$export$2e2bcd8739ae039).renderErrorMessage(err.message);
    }
};
const $f50bd1f2915ed0f2$var$init = function() {
    (0, $0d7f39475006b124$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks);
    (0, $5dccb45da00d85a7$export$2e2bcd8739ae039).addHandlerRender($f50bd1f2915ed0f2$var$controlRecipes);
    (0, $5dccb45da00d85a7$export$2e2bcd8739ae039).addHandlerUpdateServings($f50bd1f2915ed0f2$var$controlServings);
    (0, $5dccb45da00d85a7$export$2e2bcd8739ae039).addHandlerManageBookmark($f50bd1f2915ed0f2$var$controlManageBookmark);
    (0, $517cf2ae0791ab9c$export$2e2bcd8739ae039).addHandlerSearch($f50bd1f2915ed0f2$var$controlSearchResults);
    (0, $541a895ca414b984$export$2e2bcd8739ae039).addHandlerClick($f50bd1f2915ed0f2$var$controlPagination);
    (0, $8d92b1bf26236594$export$2e2bcd8739ae039).addHandlerRecipeUpload($f50bd1f2915ed0f2$var$controlAddNewRecipe);
};
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=index.a354b56f.js.map
